import { ALIGNMENT, Cell, Grid } from "baseui/layout-grid";
import { useState } from "react";
import { useParams, withRouter } from "react-router-dom";
import BannerHeading from "../../../../../_common/BannerHeading";
import UpdateExpenseForm from "../updateExpense/UpdateExpenseForm";
import AddExpenseForm from "./addExpenseForm";
import {
  FocusOnce,
  Modal,
  ModalBody,
  ModalButton,
  ModalFooter,
  ModalHeader,
} from "baseui/modal";
import authService from "../../../../../_services/auth.service";

function AddExpense() {
  const [accessModal, setAccessModal] = useState(false);
  const [accessMessage, setAccessMessage] = useState("");

  const { id } = useParams();

  const handleSubmit = () => {
    // Prevent adding/updating expenses from this application
    const user = authService.currentUser();
    const operation = id ? "update" : "creation";

    if (user?.role !== "driver") {
      setAccessMessage(
        `Expense ${operation} has been moved to MyChauffeur Admin Dashboard.\n\nPlease use the Admin Dashboard for expense management and administrative actions.`,
      );
    } else {
      setAccessMessage(
        `Expense ${operation} has been moved to the MyChauffeur Driver App.\n\nPlease use the Driver App for driver operations and expense related activities.`,
      );
    }

    setAccessModal(true);
  };

  return (
    <div className="dashboard-main">
      <Grid align={ALIGNMENT.center}>
        <Cell span={[4, 8, 12]}>
          <BannerHeading title={`Add Expense`} />
          <div className="form-box">
            <AddExpenseForm isLoading={false} onSubmit={handleSubmit} />
            {id && <UpdateExpenseForm />}
          </div>
        </Cell>
      </Grid>

      {/* Access Restriction Modal */}
      <Modal
        isOpen={accessModal}
        onClose={() => setAccessModal(false)}
        overrides={{
          Dialog: {
            style: {
              width: "420px",
            },
          },
        }}
      >
        <FocusOnce>
          <ModalHeader>Expense Management Update</ModalHeader>
        </FocusOnce>

        <ModalBody>
          <p style={{ whiteSpace: "pre-line", lineHeight: "1.6" }}>
            {accessMessage}
          </p>
        </ModalBody>

        <ModalFooter>
          <ModalButton onClick={() => setAccessModal(false)}>
            Got it
          </ModalButton>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default withRouter(AddExpense);
